import { render, staticRenderFns } from "./LightActivities.vue?vue&type=template&id=2b4b05cf&lang=pug&"
import script from "./LightActivities.vue?vue&type=script&lang=ts&"
export * from "./LightActivities.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports